 // Set your cloud name and unsigned upload preset here:
 const YOUR_CLOUD_NAME = "hoabts6mc";
 const YOUR_UNSIGNED_UPLOAD_PRESET = "be_auth_svc";


import React from "react";
import { TouchableOpacity, type ViewStyle } from "react-native";
import * as ImagePicker from 'expo-image-picker';
import axios from 'axios';


type CldUploaderProps = {
  onFinishUpload : (obj:any | undefined) => void
    onStartUpload?: () => void,
    style?:ViewStyle,
    onCancelUpload?: () => void,
  children?:any,
  disabled?:boolean,
  public_id: string
}
const ImageUploader = ({ style, disabled, onStartUpload, onFinishUpload, public_id, children }:CldUploaderProps) => {
  
  /*
  const processFile = async (file:any) => {
    if(onStartUpload){ onStartUpload() }
    //var file = e.target.files[0];
    if(!file && onCancelUpload){ onCancelUpload()}
    var POST_URL =
      "https://api.cloudinary.com/v1_1/" + YOUR_CLOUD_NAME + "/auto/upload";

    var XUniqueUploadId = +new Date();

    processFile();

    function processFile() {
      var size = file.size;
      var sliceSize = 20000000;
      var start = 0;

      setTimeout(loop, 3);

      function loop() {
        var end = start + sliceSize;

        if (end > size) {
          end = size;
        }
        var s = slice(file, start, end);
        send(s, start, end - 1, size);
        if (end < size) {
          start += sliceSize;
          setTimeout(loop, 3);
        }
      }
    }

    const send = (piece:any, start:any, end:any, size:any) => {

      var formdata = new FormData();

      formdata.append("file", piece);
      formdata.append("cloud_name", YOUR_CLOUD_NAME);
      formdata.append("upload_preset", YOUR_UNSIGNED_UPLOAD_PRESET);
      formdata.append("public_id", public_id);

      var xhr = new XMLHttpRequest();
      xhr.open("POST", POST_URL, false);
      xhr.setRequestHeader("X-Unique-Upload-Id", XUniqueUploadId as any);
      xhr.setRequestHeader(
        "Content-Range",
        "bytes " + start + "-" + end + "/" + size
      );

      xhr.onload = function () {
        // do something to response
        onFinishUpload(JSON.parse(this.responseText))
      };

      xhr.send(formdata);
    }

    function slice(file:any, start:any, end:any) {
      var slice = file.mozSlice
        ? file.mozSlice
        : file.webkitSlice
        ? file.webkitSlice
        : file.slice
        ? file.slice
        : noop;

      return slice.bind(file)(start, end);
    }

    function noop() {}
  };
  */

  const upload = async(file:any) => {
    const formData = new FormData();
    formData.append('file', file); // 'imageFile' is your selected image file
    formData.append("cloud_name", YOUR_CLOUD_NAME);
    formData.append("upload_preset", YOUR_UNSIGNED_UPLOAD_PRESET);
    formData.append("public_id", public_id);
    const uploadUrl = `https://api.cloudinary.com/v1_1/${YOUR_CLOUD_NAME}/image/upload`;
    var XUniqueUploadId = +new Date();
    try {
      const response = await axios.post(uploadUrl, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "X-Unique-Upload-Id": XUniqueUploadId,
            'Authorization': undefined,
            'x-api-key':undefined,
            'sessionid':undefined,
            'distinctid':undefined
        }
      })
      return response.data
    } catch (error) {
      return onFinishUpload(undefined)
    }
  }

  const handleClick = async() => {
    if(disabled){ return alert('Unable to update image at this time') }
      if(onStartUpload){onStartUpload()}
      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ['images', 'videos'],
        allowsEditing: true,
        base64:true,
        //aspect: [4, 3],
        quality: 1,
      });
      if(!result?.assets){ return  onFinishUpload(undefined)}
      let file = result.assets[0]
      if(!file){ return onFinishUpload(undefined) }
      let mimeType = file.mimeType
      let base_64 = file.base64
      if(!mimeType || !base_64){ return onFinishUpload(undefined) }
      let url = `data:${mimeType};base64,${base_64}`
      let object = await upload(url);
      return onFinishUpload(object)
    }
    return (
         <TouchableOpacity style={{ padding:10, ...style }} onPress={() => handleClick()}>
            {children}
        </TouchableOpacity>
    );

}

/*
<input ref={upload_ref as any} style={{ display:'none' }} type="file"  onChange={processFile} onAbort={() => onCancelUpload ? onCancelUpload() : console.log('cancelled')}/>
*/

export default ImageUploader;
